export default "__VITE_ASSET__0xqK0$q1__"